export const CREATE_SOURCE_REQUEST = 'requestSource/CREATE_SOURCE_REQUEST';
export const CREATE_SOURCE_REQUEST_SUCCESS = 'requestSource/CREATE_SOURCE_REQUEST_SUCCESS';
export const CREATE_SOURCE_REQUEST_ERROR = 'requestSource/CREATE_SOURCE_REQUEST_ERROR';
export const SET_SOURCE_NAME = 'requestSource/SET_SOURCE_NAME';
export const RESET_REQUEST_SOURCE = 'requestSource/RESET_REQUEST_SOURCE';

export const REQUEST_SOURCE_URL = '/advisor-service/sources';
